import { Position } from 'geojson'

export const calculBounds = (
  coords: Position[]
): google.maps.LatLngBoundsLiteral => ({
  north: Math.max.apply(
    null,
    coords.map((d) => d[1])
  ),
  east: Math.max.apply(
    null,
    coords.map((d) => d[0])
  ),
  south: Math.min.apply(
    null,
    coords.map((d) => d[1])
  ),
  west: Math.min.apply(
    null,
    coords.map((d) => d[0])
  ),
})

export default calculBounds
